export default __webpack_public_path__ + "static/media/box.511b55cd.svg";